import { gql } from '@apollo/client'

export default gql(`
    mutation deleteAppWidget($project: String $id: ID!
        ) {
        deleteAppWidget(
            id: $id
            project: $project
        ) {
                id
               }
               
    }`
)
